import script from "./NuestrasAlianzas.vue?vue&type=script&setup=true&lang=js"
export * from "./NuestrasAlianzas.vue?vue&type=script&setup=true&lang=js"

import "./NuestrasAlianzas.vue?vue&type=style&index=0&id=1d32c58e&scoped=true&lang=css"

import exportComponent from "/home/hans/Proyectos/Clever/AlicaMedios/alicamedios.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d32c58e"]])

export default __exports__